import { useContext, useState } from "react";
import {AppContext} from "../../context/AppContext";
import { taskListActions } from "../../context/reducer";

const FilterList = () => {
    const {state: {taskList}, dispatch} = useContext(AppContext);
    const [activeIndex, setActiveIndex] = useState(0);
    const getFilterCount = (type) => {
        let count = taskList?.filter(todo => todo[type] && todo);
        return count?.length
    }
    const handleActiveFilter = (index) => {
        setActiveIndex(index);
        let key = '';
        let tempList = [];
        
        if(index === 1) key = 'isActive';
        if(index === 2) key = 'isCompleted';
        if(index === 3) key = 'isArchived';
        if(index === 0){
            tempList = [...taskList].map(list => ({...list, show:true}));
            dispatch({type: taskListActions.UPDATE_TASKLIST, payload: tempList});
        }else{
            tempList = [...taskList].map((list => !!list[key] ? {...list, show:true} : {...list, show:false} ))
        } 
        dispatch({type: taskListActions.UPDATE_TASKLIST, payload: tempList});
    }
    return (
        <ul className="filter_list" onClick={() => {}}>
            <li 
                onClick={() => handleActiveFilter(0)}
                className={activeIndex === 0 && 'active  text-blue-600'}
            >All <span className="item-count bg-blue-600 text-white">{taskList?.length}</span></li>
            <li 
                onClick={() => handleActiveFilter(1)}
                className={activeIndex === 1 && 'active text-blue-600'}
            >Active <span className="item-count bg-blue-600 text-white">{getFilterCount('isActive')}</span></li>
            <li 
                onClick={() => handleActiveFilter(2)}
                className={activeIndex === 2 && 'active text-blue-600'}
            >Completed <span className="item-count bg-blue-600 text-white">{getFilterCount('isCompleted')}</span></li>
            <li 
                onClick={() => handleActiveFilter(3)}
                className={activeIndex === 3 && 'active text-blue-600'}
            >Archived <span className="item-count bg-blue-600 text-white">{getFilterCount('isArchived')}</span></li>
        </ul>
    )
}

export default FilterList;